import {
  BASE_URL,
  BASE_URL_CHAT,
  BASE_URL_COURIER,
  BASE_URL_PAYMENT,
  BASE_URL_TRANS,
  BASE_URL_UPLOAD_IMG,
} from "./Constants";
import axios from "axios";
import Cookies from "js-cookie";
import { CookiesDomain } from "../controller/authController";
import { isEmpty } from "../controller/globalController";
import dayjs from "dayjs";
import { globalStorage } from "./Storage";

export const ACC_TKN = 'bursakopi_acc_tkn'
export const RFSH_TKN = 'bursakopi_rfsh_tkn'
const handleExpireTkn = () => {
  Cookies.remove(ACC_TKN, { secure: true, domain: CookiesDomain })
  Cookies.remove(RFSH_TKN, { secure: true, domain: CookiesDomain })
  globalStorage.clear()
  window.location.href = '/login'
}
const callRefreshToken = async (refresh_token) => {
  if (isEmpty(refresh_token)) return handleExpireTkn()

  const postData = new FormData();
  postData.append('refresh_token', refresh_token)
  const { code, data } = await axios
    .create({ baseURL: BASE_URL, responseType: "json" })
    .post("auth/refreshtoken", postData)
    .then((res) => res.data)
  if (code !== 200) throw new Error('Token refresh failed or expired');
  const expires = dayjs().add((data?.expires_in ?? 10) * 1000, "millisecond").toDate()
  Cookies.set(ACC_TKN, data?.access_token, { secure: true, domain: CookiesDomain, expires });
  Cookies.set(RFSH_TKN, data?.refresh_token, { secure: true, domain: CookiesDomain, expires });
  return data?.access_token;
};

const AuthInInterceptor = (axiosObj) => {
  let isRefreshing = false;
  let failedQueue = [];

  axiosObj.interceptors.request.use(
    (req) => {
      const token = Cookies.get(ACC_TKN);
      if (isEmpty(token)) return handleExpireTkn()
      if (!isEmpty(token)) req.headers.Authorization = `Bearer ${token}`
      return req
    },
    (err) => Promise.reject(err)
  )

  axiosObj.interceptors.response.use(
    (res) => res,
    async (err) => {
      const oriReq = err.config
      const status = err?.response?.status

      if ([401].includes(status) && !oriReq._retry) {
        oriReq._retry = true

        if (!isRefreshing) {
          isRefreshing = true;
          try {
            const newToken = await callRefreshToken();
            failedQueue.forEach((callback) => callback(newToken));
            failedQueue = [];

            oriReq.headers.Authorization = `Bearer ${newToken}`;
            return axiosObj(oriReq);
          } catch (refreshError) {
            return Promise.reject(refreshError);
          } finally {
            isRefreshing = false;
          }
        } else {
          return new Promise((resolve, reject) => {
            failedQueue.push((newToken) => {
              oriReq.headers.Authorization = `Bearer ${newToken}`;
              resolve(axiosObj(oriReq));
            });
          });
        }
      }
      return Promise.reject(err?.response ?? err?.data)
    }
  )

  return axiosObj;
};

// API 1toko
export const API = axios.create({ baseURL: BASE_URL, responseType: "json" });
export const APITransNoAuth = axios.create({ baseURL: BASE_URL_TRANS, responseType: "json" });

export const APIAuth = AuthInInterceptor(
  axios.create({ baseURL: BASE_URL, responseType: "json" })
);

export const APIAuthFile = AuthInInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: { "content-type": "multipart/form-data" },
  responseType: "json",
}));

export const APITrans = AuthInInterceptor(
  axios.create({ baseURL: BASE_URL_TRANS, responseType: "json" })
);

export const APIPayment = AuthInInterceptor(
  axios.create({ baseURL: BASE_URL_PAYMENT, responseType: "json" })
);

export const APICourier = AuthInInterceptor(
  axios.create({ baseURL: BASE_URL_COURIER, responseType: "json" })
);

export const APIChat = AuthInInterceptor(
  axios.create({ baseURL: BASE_URL_CHAT, responseType: "json" })
);

export const APIImg = axios.create({
  baseURL: BASE_URL_UPLOAD_IMG,
  headers: { "content-type": "multipart/form-data" },
  responseType: "json",
});

export default API;
